module.exports = __webpack_public_path__ + "media/images/bg-landing-866bbf0d780aa760ce1c7e72bc0a9a1f.jpg";